import { dom } from './dom.js';
import { apiCounter, incrementApiCounter, decrementApiCounter } from './state.js';
import { hideLoadingText } from './loader.js';

export async function apiFetch(url, options = {}) {
  incrementApiCounter();
  if (dom.loadingOverlay) dom.loadingOverlay.classList.add("show");
  if (["PUT", "POST", "DELETE"].includes(options.method) && dom.savingIndicator) dom.savingIndicator.classList.remove("hidden");
  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      let msg;
      try {
        msg = (await response.json()).error || `HTTP error! Status: ${response.status}`;
      } catch (e) {
        msg = response.statusText || `HTTP error! Status: ${response.status}`;
      }
      throw new Error(msg);
    }
    const contentType = response.headers.get("content-type");
    const contentLength = response.headers.get("Content-Length");
    if (response.status === 204 || !contentType || contentLength === "0") return null;
    return contentType.includes("application/json") ? response.json() : response.text();
  } finally {
    decrementApiCounter();
    if (apiCounter === 0) {
        if (dom.loadingOverlay) dom.loadingOverlay.classList.remove("show");
        hideLoadingText();
    }
    if (dom.savingIndicator) dom.savingIndicator.classList.add("hidden");
  }
}

export function getPhotosForTrack(trackId) {
  return apiFetch(`/api/v1/track/${trackId}/photos`);
}

export function uploadPhoto(trackId, formData) {
  return apiFetch(`/api/v1/track/${trackId}/photo`, {
    method: 'POST',
    body: formData,
  });
}

// bulkUploadPhotos sends up to 20 photos to the bulk upload endpoint.
// onProgress(loaded, total) is called periodically if provided.
export function bulkUploadPhotos(formData, idempotencyKey, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/v1/photos/bulk');
    if (idempotencyKey) xhr.setRequestHeader('Idempotency-Key', idempotencyKey);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    if (onProgress) {
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) onProgress(e.loaded, e.total);
      };
    }
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try { resolve(JSON.parse(xhr.responseText)); }
        catch (e) { reject(new Error('Invalid JSON response')); }
      } else {
        let msg = `HTTP ${xhr.status}`;
        try { msg = JSON.parse(xhr.responseText).error || msg; } catch (_) {}
        reject(new Error(msg));
      }
    };
    xhr.onerror = () => reject(new Error('Network error during upload'));
    xhr.send(formData);
  });
}

export function deletePhoto(photoId) {
  return apiFetch(`/api/v1/photo/${photoId}`, {
    method: 'DELETE',
  });
}

export function getSharedPhotos(shareId) {
  return apiFetch(`/api/v1/shared/track/${shareId}/photos`);
}

export function getSharedTripPhotos(shareId) {
  return apiFetch(`/api/v1/shared/trip/${shareId}/photos`);
}

export function getSharedNotes(shareId) {
  return apiFetch(`/api/v1/shared/track/${shareId}/notes`);
}

export function getSharedTripNotes(shareId) {
    return apiFetch(`/api/v1/shared/trip/${shareId}/notes`);
}

export function updatePhotoCaption(photoId, caption) {
  return apiFetch(`/api/v1/photo/${photoId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ caption }),
  });
}

export function getNotesForTrack(trackId) {
  return apiFetch(`/api/v1/track/${trackId}/notes`);
}

export function saveNote(pointId, content) {
  return apiFetch(`/api/v1/point/${pointId}/note`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ content }),
  });
}

export function deleteNote(noteId) {

  return apiFetch(`/api/v1/note/${noteId}`, {

    method: 'DELETE',

  });

}



export function boatAgent(boatData) {

    return apiFetch('/api/v1/boat/agent', {

        method: 'POST',

        headers: {

            'Content-Type': 'application/json',

        },

        body: JSON.stringify(boatData),

    });

}

export function updatePersonProfile(data) {

  return apiFetch('/api/v1/me', {

    method: 'PUT',

    headers: {

      'Content-Type': 'application/json',

    },

    body: JSON.stringify(data),

  });

}



export function listTripCrew(tripId) {

  return apiFetch(`/api/v1/trip/${tripId}/crew`);

}



export function listTrackCrew(trackId) {

  return apiFetch(`/api/v1/track/${trackId}/crew`);

}



export function addCrew(trackId, data) {

  return apiFetch(`/api/v1/track/${trackId}/crew`, {

    method: 'POST',

    headers: {

      'Content-Type': 'application/json',

    },

    body: JSON.stringify(data),

  });

}



export function removeCrew(trackId, crewMemberId) {

  return apiFetch(`/api/v1/track/${trackId}/crew/${crewMemberId}`, {

    method: 'DELETE',

  });

}



export function updateCrew(trackId, crewMemberId, data) {

  return apiFetch(`/api/v1/track/${trackId}/crew/${crewMemberId}`, {

    method: 'PUT',

    headers: {

      'Content-Type': 'application/json',

    },

    body: JSON.stringify(data),

  });

}

export function importData(formData) {
  return apiFetch('/api/v1/import', {
    method: 'POST',
    body: formData,
  });
}

export function getCharterCompanies() {
  return apiFetch('/api/v1/boat/charter-companies');
}

export function getCruisingRegions() {
  return apiFetch('/api/v1/boat/cruising-regions');
}

export function listCredentials(kind = '') {
  const url = kind ? `/api/v1/credential?kind=${encodeURIComponent(kind)}` : '/api/v1/credential';
  return apiFetch(url);
}

export function createCredential(cred) {
  return apiFetch('/api/v1/credential', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cred),
  });
}

export function updateCredential(id, cred) {
  return apiFetch(`/api/v1/credential/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cred),
  });
}

export function deleteCredentialById(id) {
  return apiFetch(`/api/v1/credential/${id}`, { method: 'DELETE' });
}

export function getCredentialOrganizations(kind = '') {
  const url = kind ? `/api/v1/credential/organizations?kind=${encodeURIComponent(kind)}` : '/api/v1/credential/organizations';
  return apiFetch(url);
}

export function getCredentialNames(kind = '', organization = '') {
  const params = new URLSearchParams();
  if (kind) params.set('kind', kind);
  if (organization) params.set('organization', organization);
  const qs = params.toString();
  return apiFetch(qs ? `/api/v1/credential/names?${qs}` : '/api/v1/credential/names');
}
